import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

type LoggedOutState = {
  isLoggedIn: false;
  user: null;
  token:"";
};

type LoggedInState = {
  isLoggedIn: false;
  user: {
    id: string;
    token: string;
    email: string;
    profilePhoto: string;
    user_type: string;
    fullName: string;
    username?: string;
  };
};

export type AuthStateType = LoggedOutState | LoggedInState;


const { persistAtom } = recoilPersist({
  key: "auth",
  storage: localStorage,
});

export const getRefreshAtom = atom({
  key: "get_refreash",
  default: false,
});

export default atom<AuthStateType>({
  key: "auth",
  default: {
    isLoggedIn: false,
    user: null,
    token: "",
  },
  effects_UNSTABLE: [persistAtom],
});
